import { render } from "./TextButton.vue?vue&type=template&id=01c746b2&scoped=true"
import script from "./TextButton.vue?vue&type=script&lang=js"
export * from "./TextButton.vue?vue&type=script&lang=js"

import "./TextButton.vue?vue&type=style&index=0&id=01c746b2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c746b2"]])

export default __exports__